import React from "react";
import "./clientrows.css";
import { s3url } from "../utility/constand";

const leftCarouselItems = [
  {
    imgSrc: "/images/Salary Slip.svg",
    text: "Salary Slip",
    className: "left-carosul-items left-item1",
  },
  {
    imgSrc: "/images/Bank Statement.svg",
    text: "Bank Statement",
    className: "left-carosul-items left-item2",
  },
  {
    imgSrc: "/images/Invoice.svg",
    text: "Invoice",
    className: "left-carosul-items left-item3",
  },
  {
    imgSrc: `${s3url}/Personal Docs.svg`,
    text: "Personal Docs",
    className: "left-carosul-items left-item4",
  },
  {
    imgSrc: "/images/Salary Slip.svg",
    text: "Salary Slip",
    className: "left-carosul-items left-item5",
  },
  {
    imgSrc: "/images/Bank Statement.svg",
    text: "Bank Statement",
    className: "left-carosul-items left-item6",
  },
  {
    imgSrc: "/images/Invoice.svg",
    text: "Invoice",
    className: "left-carosul-items left-item7",
  },
  {
    imgSrc: `${s3url}/Personal Docs.svg`,
    text: "Personal Docs",
    className: "left-carosul-items left-item8",
  },
  {
    imgSrc: "/images/Salary Slip.svg",
    text: "Salary Slip",
    className: "left-carosul-items left-item9",
  },
  {
    imgSrc: "/images/Bank Statement.svg",
    text: "Bank Statement",
    className: "left-carosul-items left-item10",
  },
  {
    imgSrc: "/images/Invoice.svg",
    text: "Invoice",
    className: "left-carosul-items left-item11",
  },
  {
    imgSrc: `${s3url}/Personal Docs.svg`,
    text: "Personal Docs",
    className: "left-carosul-items left-item12",
  },
  {
    imgSrc: "/images/Salary Slip.svg",
    text: "Salary Slip",
    className: "left-carosul-items left-item13",
  },
  {
    imgSrc: "/images/Bank Statement.svg",
    text: "Bank Statement",
    className: "left-carosul-items left-item14",
  },
  {
    imgSrc: "/images/Invoice.svg",
    text: "Invoice",
    className: "left-carosul-items left-item15",
  },
  {
    imgSrc: `${s3url}/Personal Docs.svg`,
    text: "Personal Docs",
    className: "left-carosul-items left-item16",
  },
  {
    imgSrc: "/images/Salary Slip.svg",
    text: "Salary Slip",
    className: "left-carosul-items left-item17",
  },
];
const rightCarouselItems = [
  {
    imgSrc: "/images/Salary Slip (1).svg",
    text: "Salary Slip",
    className: "right-carosul-items right-item5",
  },
  {
    imgSrc: "/images/Bank Statement (1).svg",
    text: "Bank Statement",
    className: "right-carosul-items right-item6",
  },
  {
    imgSrc: "/images/Invoice (1).svg",
    text: "Invoice",
    className: "right-carosul-items right-item7",
  },
  {
    imgSrc: `${s3url}/Personal Docs (1).svg`,
    text: "Personal Docs",
    className: "right-carosul-items right-item8",
  },
  {
    imgSrc: "/images/Salary Slip (1).svg",
    text: "Salary Slip",
    className: "right-carosul-items right-item9",
  },
  {
    imgSrc: "/images/Bank Statement (1).svg",
    text: "Bank Statement",
    className: "right-carosul-items right-item10",
  },
  {
    imgSrc: "/images/Invoice (1).svg",
    text: "Invoice",
    className: "right-carosul-items right-item11",
  },
  {
    imgSrc: `${s3url}/Personal Docs (1).svg`,
    text: "Personal Docs",
    className: "right-carosul-items right-item12",
  },
  {
    imgSrc: "/images/Salary Slip (1).svg",
    text: "Salary Slip",
    className: "right-carosul-items right-item13",
  },
  {
    imgSrc: "/images/Bank Statement (1).svg",
    text: "Bank Statement",
    className: "right-carosul-items right-item14",
  },
  {
    imgSrc: "/images/Invoice (1).svg",
    text: "Invoice",
    className: "right-carosul-items right-item15",
  },
  {
    imgSrc: `${s3url}/Personal Docs (1).svg`,
    text: "Personal Docs",
    className: "right-carosul-items right-item16",
  },
  {
    imgSrc: "/images/Salary Slip (1).svg",
    text: "Salary Slip",
    className: "right-carosul-items right-item17",
  },
  {
    imgSrc: "/images/Bank Statement (1).svg",
    text: "Bank Statement",
    className: "right-carosul-items right-item1",
  },
  {
    imgSrc: "/images/Invoice (1).svg",
    text: "Invoice",
    className: "right-carosul-items right-item2",
  },
  {
    imgSrc: `${s3url}/Personal Docs (1).svg`,
    text: "Personal Docs",
    className: "right-carosul-items right-item3",
  },
  {
    imgSrc: "/images/Salary Slip (1).svg",
    text: "Salary Slip",
    className: "right-carosul-items right-item4",
  },
];
function ClientRows() {
  return (
    <div className="rows-wrapper">
      <div className="rows-text-section">
        <h1 className="row-text-heading">
          Get Insights in
          <br />
          <span> Just One </span>
          Click
        </h1>
      </div>
      <div className="client-carosul-animation">
        <div className="carosul-left-wrapper">
          <CarouselSection items={leftCarouselItems} />
        </div>
        <img
          src="/images/Shield.svg"
          alt=""
          width="20rem"
          loading="lazy"
          decoding="async"
          className="shied_image1"
        />
        {/* <div className="generatecomponent">
          <GenerateNumber />
        </div> */}
        <div className="carosul-right-wrapper">
          <CarouselSection items={rightCarouselItems} />
        </div>
      </div>

      <img
        src="/images/Shield.svg"
        alt=""
        loading="lazy"
        decoding="async"
        className="shied_image"
      />
    </div>
  );
}

export default React.memo(ClientRows);

const ImageAndText = React.memo(({ imgSrc, text, classname }) => {
  return (
    <div className={`image-group ${classname}`}>
      <img src={imgSrc} alt="" loading="lazy" decoding="async" />
      <figcaption>{text}</figcaption>
    </div>
  );
});
const CarouselSection = React.memo(({ items }) => (
  <div className="carousel-wrapper">
    {items.map((item, index) => (
      <ImageAndText
        key={index}
        imgSrc={item.imgSrc}
        text={item.text}
        classname={item.className}
      />
    ))}
  </div>
));
